export enum MetaFeatureType {
  PAGE = 'page',
  WIDGET = 'widget',
}

/**
 * List of possible values for Pesentation forms
 * @category Basic KUX Configuration
 */
export enum AssetPresentationFormEnum {
  circle = 'circle',
  landscape = 'landscape',
  portrait = 'portrait',
}

export enum AssetImageSourceEnum {
  manual = 'manual',
}

export enum AssetStructEnum {
  default = 'Default',
  program = 'Program',
  linear = 'Linear',
  movie = 'Movie',
  series = 'Series',
  episode = 'Episode',
  recording = 'recording',
}

/**
 * List for selection of possible values of Image Ratios
 *
 */
export enum AssetPresentationRatioEnum {
  '1x1' = '1x1',
  '16x9' = '16x9',
  '3x4' = '3x4',
  '2x3' = '2x3',
  '5x3' = '5x3',
}

export enum RecordingTypeEnum {
  'all' = 'all',
  'latest' = 'latest',
  'series' = 'series',
}

export enum TypesContinueWatching {
  ALL = 'ALL',
  PROGRESS = 'PROGRESS',
  DONE = 'DONE',
}

export enum ShowMoreActions {
  grid = 'grid',
  deeplink = 'deeplink',
}

/**
 * List of possible values
 * @category Basic KUX Configuration
 */
export enum LCBatchesPresentationOrderEnum {
  fav = 'fav',
  top_x = 'top_x',
  lcn = 'lcn',
}

/**
 * List of possible values
 * @category Basic KUX Configuration
 */
export enum RatingProviderEnum {
  imdb = 'imdb',
  kp = 'kp',
  star = 'star',
  o2 = 'o2',
  tvprofi = 'tvprofi',
  serialzone = 'serialzone',
}

/**
 * List of possible values
 * @category Basic KUX Configuration
 */
export enum UIDAPresentationTypeEnum {
  container = 'container', // Page
  menu = 'menu', // Menu
  hero = 'hero', // Rail
  cw = 'cw', // Rail
  collection = 'collection', // Rail
  footer = 'footer', // Menu
  apps = 'apps', // Rail
  zapper = 'zapper', // Page
  folder = 'folder', // Menu
  login = 'login', // Page
  settings = 'settings', // Page
  subscription = 'subscription', // Page / ??
  asset_details_page = 'asset_details_page', // Page
  blocked_channels = 'blocked_channels', // Page
  parental_control = 'parental_control', // Page
  epg = 'epg', // Page
  applications = 'applications', // Rail/Page
  language = 'language',
  favorites = 'favorites', // Page
  devices = 'devices',
  link_list = 'link_list',
  transaction_history = 'transaction_history', // Page
  npvr = 'npvr', // Page/Rail
  personal_lineup = 'personal_lineup',
  preferred_video_quality = 'preferred_video_quality',
  series_catch_up = 'series_catch_up', // Rail/Page
  grid = 'grid', // Rail/Page
  tvod = 'tvod', // Rail
  menu_item = 'menu_item', // Menu
  menu_sub = 'menu_sub', // Menu
  suggested = 'suggested', // Rail
  channel_api = 'channel_api', // Rails
  search = 'search',
  top_shelf = 'top_shelf', //TopShelf
  top_shelf_carousel = 'top_shelf_carousel',
  series_recordings = 'series_recordings', // Page
  player = 'player',
  device_info = 'device_info',
  deeplink = 'deeplink',
}

export enum PresentationAdditionalTypeEnum {
  series_additional_rail = 'series_additional_rail',
  record_additional_rail = 'record_additional_rail',
}
/**
 *
 */
export type PageStoreSubTypes =
  | UIDAPresentationTypeEnum.container
  | UIDAPresentationTypeEnum.npvr
  | UIDAPresentationTypeEnum.settings
  | UIDAPresentationTypeEnum.applications
  | UIDAPresentationTypeEnum.epg;

export type RailStoreSubTypes =
  | UIDAPresentationTypeEnum.apps
  | UIDAPresentationTypeEnum.collection
  | UIDAPresentationTypeEnum.cw
  | UIDAPresentationTypeEnum.hero
  | UIDAPresentationTypeEnum.tvod
  | UIDAPresentationTypeEnum.series_catch_up
  | UIDAPresentationTypeEnum.suggested
  | UIDAPresentationTypeEnum.npvr
  | UIDAPresentationTypeEnum.channel_api
  | UIDAPresentationTypeEnum.grid
  | UIDAPresentationTypeEnum.top_shelf_carousel
  | PresentationAdditionalTypeEnum.series_additional_rail
  | PresentationAdditionalTypeEnum.record_additional_rail;
/**
 * List of possible values
 * @category Basic KUX Configuration
 */
export enum UIDAStructureTypeEnum {
  aside = 'aside',
  root = 'root',
  page = 'page',
  widget = 'widget',
  menu = 'menu',
  subpage = 'subpage',
}

/**
 * Possible Types for Links
 * @category Basic KUX Configuration
 */
export enum TypeOfApplicationLink {
  page = 'page',
  asset = 'asset',
  external = 'external',
  grid = 'grid',
}

export enum DynamicDataTypeEnum {
  ageThreshold = 'age_threshold',
  pinForPurchase = 'pin_for_purchase',
  language = 'display_language',
  audioLanguage = 'audio_language',
  subtitleLanguage = 'subtitle_language',
  customerType = 'customer_type',
  interestLastUpdate = 'interest_last_update',
  migratedFlag = 'Migrated_flag',
  householdBandwidth = 'household_bandwidth',
  hboGoCode = 'hbo_go_code',
}

export enum MenuItemPin {
  left = 'left',
  right = 'right',
}

export enum DisplayType {
  text = 'text',
  image = 'image',
  both = 'both',
  textOnly = 'textOnly',
  imageOnly = 'imageOnly',
}

export enum ButtonTypes {
  login = 'login',
  sign_up = 'sign_up',
}

export enum SearchKeys {
  name = 'name',
  original_name = 'original_name',
  actors = 'actors',
  director = 'director',
}

export enum AdditionalSearchKey {
  original_name = 'originalname',
}

export enum SecondButtonActions {
  details_page = 'details_page',
  epg_page = 'epg_page',
}

export enum ChannelPersonalizationIndicator {
  Favorites = 'Favorites',
  PersonalLineup = 'PersonalLineup',
  None = 'None',
}
